module.exports = "https://cdn-shared.mathletics.com/teacher-modules/upf-assign/73/assets/images/10523f40e6f313ebdeed2ce159f158bf.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/arrow_down.svg
// module id = /4Ah
// module chunks = 0